var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-link",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
      },
    },
    [
      !_vm.wishListCount
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "34.578",
                height: "31.193",
                viewBox: "0 0 34.578 31.193",
              },
            },
            [
              _c("path", {
                attrs: {
                  "data-name": "heart-line",
                  d: "M19.291,34.76a1.081,1.081,0,0,1-.659-.227C12.623,29.864,8.484,25.844,5.588,21.878c-3.7-5.069-4.539-9.748-2.507-13.909C4.529,5,8.689,2.565,13.553,3.981a10.667,10.667,0,0,1,5.739,4.074A10.667,10.667,0,0,1,25.03,3.981C29.883,2.587,34.054,5,35.5,7.969c2.032,4.161,1.189,8.84-2.507,13.909-2.9,3.966-7.036,7.987-13.044,12.655A1.081,1.081,0,0,1,19.291,34.76ZM10.786,5.743a6.376,6.376,0,0,0-5.76,3.167c-1.675,3.437-.919,7.262,2.313,11.683A61.742,61.742,0,0,0,19.291,32.307,61.742,61.742,0,0,0,31.244,20.6c3.242-4.431,3.988-8.257,2.313-11.683-1.081-2.161-4.323-3.88-7.933-2.864a8.646,8.646,0,0,0-5.339,4.539,1.081,1.081,0,0,1-2,0,8.57,8.57,0,0,0-5.339-4.539,7.9,7.9,0,0,0-2.161-.313Z",
                  transform: "translate(-2.003 -3.567)",
                  fill: "#fff",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "mr-2 b-count" }, [
        _vm._v(_vm._s(_vm.wishListCount)),
      ]),
      _vm._v(" "),
      _vm.wishListCount
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "34.578",
                height: "31.193",
                viewBox: "0 0 34.578 31.193",
              },
            },
            [
              _c("path", {
                attrs: {
                  "data-name": "heart-line",
                  d: "M19.291,34.76a1.081,1.081,0,0,1-.659-.227C12.623,29.864,8.484,25.844,5.588,21.878c-3.7-5.069-4.539-9.748-2.507-13.909C4.529,5,8.689,2.565,13.553,3.981a10.667,10.667,0,0,1,5.739,4.074A10.667,10.667,0,0,1,25.03,3.981C29.883,2.587,34.054,5,35.5,7.969c2.032,4.161,1.189,8.84-2.507,13.909-2.9,3.966-7.036,7.987-13.044,12.655A1.081,1.081,0,0,1,19.291,34.76Z",
                  transform: "translate(-2.003 -3.567)",
                  fill: "#fff",
                },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }